import { Abac } from '@gunosy/media-admin-components'
import cx from 'classnames'
import React, { Fragment } from 'react'
import { Nav, NavItem, NavLink } from 'reactstrap'
import { useDispatch, useSelector } from 'react-redux'
import { SelectIsInhouse, SelectLoggedInUser } from '../../store/loggedInUser'
import { UIStateActions } from '../../store/uiState'
import { Menu } from './NavItems'

const VerticalNav: React.FC = () => {
  const dispatch = useDispatch()
  const loggedInUser = useSelector(SelectLoggedInUser)
  const isInhouse = useSelector(SelectIsInhouse)
  const currentHash = window.location.hash

  const handleNavClick = () => {
    dispatch(UIStateActions.setEnableClosedSidebar(false))
    dispatch(UIStateActions.setEnableMobileMenu(false))
  }

  return (
    <Fragment>
      <h5
        className="app-sidebar__heading"
        style={{
          color: '#222',
          padding: '2px 0 8px',
          fontSize: '1rem',
          textTransform: 'initial',
        }}
      >
        {'Gunosy Publisher Center'}
      </h5>
      {Menu.map(ms => {
        const viewableItems = ms.items.filter(i => {
          if (!i.resource) {
            return true
          }
          const hide = i.hide ? i.hide : () => false
          return loggedInUser.abac.can(Abac.Action.List, i.resource) && !hide(isInhouse, loggedInUser)
        })

        if (viewableItems.length > 0) {
          return (
            <div key={ms.id}>
              <h5 className="app-sidebar__heading">{ms.title}</h5>
              <Nav vertical className="vertical-nav-menu">
                {viewableItems.map(item => {
                  const isActive =
                    item.to &&
                    (currentHash === item.to ||
                      (item.to === '#/reports/dashboard' && currentHash === '#/reports/dashboard/') ||
                      (item.to === '#/reports/dashboard' &&
                        (currentHash === '' || currentHash === '#' || currentHash === '#/')))
                  const itemKey = `${ms.id}:${item.id}`
                  return (
                    <NavItem key={itemKey} className="metismenu-item">
                      <NavLink
                        href={item.externalLink ? item.to : undefined}
                        target={item.externalLink ? '_blank' : undefined}
                        rel={item.externalLink ? 'noopener noreferrer' : undefined}
                        onClick={
                          item.externalLink
                            ? undefined
                            : () => {
                                handleNavClick()
                                if (item.to) {
                                  window.location.hash = item.to.replace('#', '')
                                }
                              }
                        }
                        className={cx('nav-item-hover', { active: isActive })}
                      >
                        <item.icon className="nav-item-hover__icon" />
                        <span className="nav-item-hover__label">{item.label}</span>
                      </NavLink>
                    </NavItem>
                  )
                })}
              </Nav>
            </div>
          )
        }
        return null
      })}
    </Fragment>
  )
}

export default VerticalNav
